import React, { useEffect, useState, memo } from "react";
import { useLocation, Link } from "react-router-dom";
import PwaInstallPrompt from "../../Pages/PwaInstallPrompt";

const footerLinks = [
  {
    title: "About",
    links: [
      { name: "Contact Us", redirect: "contact" },
      { name: "About Us", redirect: "about" },
      { name: "Careers", redirect: "careers" },
      { name: "Return Policy", redirect: "returnpolicy" },
      { name: "Terms Of Use", redirect: "term&conditions" },
    ],
  },
  {
    title: "Social",
    links: [
      {
        name: "Facebook",
        redirect: "https://www.facebook.com/share/15NVZUbLCd/",
      },
      {
        name: "Instagram",
        redirect:
          "https://www.instagram.com/siddhi_creatives/profilecard/?igsh=MXh3eGxld21lbXF2ZA==",
      },
      {
        name: "WhatsApp",
        redirect: `https://wa.me/9057810542?text=Hello%2C%20I%20would%20like%20more%20information%21`,
      },
    ],
  },
];

const Footer = memo(() => {
  const location = useLocation();
  const [adminRoute, setAdminRoute] = useState(false);

  useEffect(() => {
    setAdminRoute(location.pathname.split("/", 2).includes("admin"));
  }, [location]);

  const renderLinks = (links) => (
    <ul>
      {links.map((link, index) => (
        <li key={index} className="mb-2">
          <Link
            to={link.redirect}
            className="hover:text-white transition duration-200"
          >
            {link.name}
          </Link>
        </li>
      ))}
    </ul>
  );

  const renderSocialLinks = (links) => (
    <ul>
      {links.map((link, index) => (
        <li key={index} className="mb-2">
          <a
            href={link.redirect}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition duration-200"
          >
            {link.name}
          </a>
        </li>
      ))}
    </ul>
  );

  if (adminRoute) return null;

  return (
    <footer className="mt-20 bg-primary-darkBlue text-white text-sm py-8 border-t border-gray-600">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 px-4">
        {/* About Section */}
        <div>
          <h2 className="text-primary-grey font-semibold uppercase mb-4 ">
            About
          </h2>
          {renderLinks(footerLinks[0].links)}
        </div>

        {/* Social Section */}
        <div>
          <h2 className="text-primary-grey font-semibold uppercase mb-4">
            Social
          </h2>
          {renderSocialLinks(footerLinks[1].links)}
        </div>

        {/* Mail Us Section */}
        <div>
          <h2 className="text-primary-grey font-semibold uppercase mb-4">
            Mail Us
          </h2>
          <p className="leading-6">
            support@siddhicreatives.com
          </p>
          <React.Suspense fallback={null}>
            <PwaInstallPrompt />
          </React.Suspense>
        </div>

        {/* Registered Office Section */}
        <div>
          <h2 className="text-primary-grey font-semibold uppercase mb-4">
            Registered Office
          </h2>
          <p className="leading-6">
            Basement, Dukaan Khasra No.133,
            <br />
            Govindpura Sanganer, Jaipur
            <br />
            Rajasthan, India, Pin 302029,
            <br />
            Telephone: +91 90578 10542, +91 96100 62609
            <br />
            GST: 08EVPPP3955P1ZD
            <br />
            MSME: UDYAM-RJ-17-0422516
          </p>
        </div>
      </div>
    </footer>
  );
});

export default Footer;
